import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainMenu from "./components/MainMenu";
import CollectionPage from "./components/CollectionPage";
import DecksPage from "./components/DecksPage";
import RulesPage from "./components/RulesPage";
import "./styles/main.scss";

const App = () => {
  return (
    <Router basename="/MyTableTopia">
      <Routes>
        <Route path="/" element={<MainMenu />} />
        <Route path="/collection" element={<CollectionPage />} />
        <Route path="/decks" element={<DecksPage />} />
        <Route path="/rules" element={<RulesPage />} />
        {/* Catch-All Route */}
        <Route path="*" element={<MainMenu />} />
      </Routes>
    </Router>
  );
};

export default App;
